import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import Select from '@rio-cloud/rio-uikit/Select';
import classNames from 'classnames';
import { FunctionComponent, useId, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { MeansOfTransportType } from '../../../../sharedComponents/common.types';
import { InputSign } from '../../../../sharedComponents/InputSign';

const MEANS_OF_TRANSPORT_TYPES: { id: string; labelId: string }[] = [
    {
        id: MeansOfTransportType.TRUCK,
        labelId: 'outboundOrderBook.common.meansOfTransportType.truck',
    },
    {
        id: MeansOfTransportType.OWN_WHEELS,
        labelId: 'outboundOrderBook.common.meansOfTransportType.ownWheels',
    },
    {
        id: MeansOfTransportType.TRAIN,
        labelId: 'outboundOrderBook.common.meansOfTransportType.train',
    },
    {
        id: MeansOfTransportType.RORO_VESSEL,
        labelId: 'outboundOrderBook.common.meansOfTransportType.roroVessel',
    },
    {
        id: MeansOfTransportType.CONTAINER_VESSEL,
        labelId: 'outboundOrderBook.common.meansOfTransportType.containerVessel',
    },
];

type MeansOfTransportTypeInputProps = {
    value: MeansOfTransportType | undefined;
    disabled?: boolean | undefined;
    validationErrorId?: string | undefined;
    onMeansOfTransportTypeChanged?: (meansOfTranportType: MeansOfTransportType | undefined) => void | undefined;
};

export const MeansOfTransportTypeInput: FunctionComponent<MeansOfTransportTypeInputProps> = ({
    disabled = false,
    value,
    validationErrorId = undefined,
    onMeansOfTransportTypeChanged = () => {},
}) => {
    const meansOfTransportTypeInputId = useId();

    const intl = useIntl();
    const options = useMemo(
        () =>
            MEANS_OF_TRANSPORT_TYPES.map(({ id, labelId }) => ({
                id,
                label: intl.formatMessage({ id: labelId }),
            })),
        [intl],
    );

    const hasError = validationErrorId !== undefined;

    return (
        <div className="form-group">
            <FormLabel htmlFor={meansOfTransportTypeInputId}>
                <FormattedMessage id="outboundOrderBook.compoundManagement.sidebar.meansOfTransportType" />
            </FormLabel>
            <div
                className={classNames('margin-0 flex-basis-100pct', {
                    'form-group has-error has-feedback margin-bottom-25': hasError,
                })}
            >
                <Select
                    id={meansOfTransportTypeInputId}
                    disabled={disabled}
                    value={value ? [value] : []}
                    options={options}
                    placeholder={intl.formatMessage({
                        id: 'outboundOrderBook.compoundManagement.sidebar.selectMeansOfTransportType',
                    })}
                    onChange={(item) => onMeansOfTransportTypeChanged(item?.id as MeansOfTransportType | undefined)}
                />
                {hasError && <InputSign messageId={validationErrorId} glyph="rioglyph-error-sign" />}
            </div>
        </div>
    );
};
